(() => {
  const playerStates = window.WeakMap ? new WeakMap() : new Map();
  const timers = window.WeakMap ? new WeakMap() : new Map();

  window.swinger.eventHub.register('scroll', window, () => {
    window.swinger.$('.swinger-hero').forEach((hero) => {
      if (hero.matches('.swinger-hero--is-owned') && playerStates[hero] !== 'swinger-video-player:pause') {
        return;
      }

      const player = window.swinger.players.find((player) => hero.contains(player.elements.container));
      if (player) {
        try {
          if (player.fullscreen.active) {
            Promise.resolve(player.fullscreen.exit()).catch((e) => console.log(e));
          }
        } catch (e) {
          // noop
        }
        player.pause();

        window.clearTimeout(timers[hero]);
        if (player.elements.container.contains(document.activeElement)) {
          const control = hero.querySelector('.plyr__control--overlaid');

          if (control) {
            control.focus();
          }
        }
        hero.classList.remove('swinger-hero--is-playing');
      }
    });
  });

  window.swinger.eventHub.register('swinger-video-player:play swinger-video-player:playing swinger-video-player:seeking swinger-video-player:seeked swinger-video-player:pause swinger-video-player:ended', '.swinger-hero .swinger-video-player', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const hero = elem.closest('.swinger-hero');

    switch (true) {
      default:
        window.clearTimeout(timers[hero]);
        playerStates[hero] = e.type;
        break;

      case e.type === 'swinger-video-player:seeked':
      case e.type === 'swinger-video-player:seeking':
        break;
    }

    switch (true) {
      default:
        timers[hero] = window.setTimeout(() => {
          hero.classList.remove('swinger-hero--is-playing');
        }, 500);
        break;

      case e.type === 'swinger-video-player:pause':
        timers[hero] = window.setTimeout(() => {
          hero.classList.remove('swinger-hero--is-playing');
        }, 5000);
        break;

      case e.type === 'swinger-video-player:ended':
        hero.classList.remove('swinger-hero--is-playing');
        break;

      case e.type === 'swinger-video-player:seeked':
      case e.type === 'swinger-video-player:seeking':
        break;

      case e.type === 'swinger-video-player:play':
      case e.type === 'swinger-video-player:playing':
      case window.cjs && window.cjs.state === 'buffering':
        timers[hero] = window.setTimeout(() => {
          hero.classList.add('swinger-hero--is-playing');

          const player = e.detail.plyr;

          if (!player) {
            return;
          }

          const videoPlayer = player.elements.container.closest('.swinger-video-player');
          const playPauseControl = videoPlayer.querySelector('[data-plyr="play"]');

          if (playPauseControl) {
            playPauseControl.focus();
          }
        }, 200);
        break;
    }
  });

  window.swinger.observer.initialize('.swinger-hero[data-itemnumber]', (elem) => {
    const itemNumber = elem.getAttribute('data-itemnumber');
    const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
    let notificationShown = false;

    const checkBlocked = () => {
      if (itemOwnState.status !== 'blocked' || notificationShown) {
        return;
      }

      window.swinger.i18n()
        .then((i18n) => {
          notificationShown = true;

          window.swinger.snackbar.create({
            children: [
              {
                component: 'notification',
                data: {
                  type: 'error',
                  text: i18n('ui.hero.notification.blocked.text'),
                  button: {
                    href: window.swinger.config.pages.contact,
                    text: i18n('ui.shared.contact-form.label'),
                  },
                },
              },
            ],
          });
        })
        .catch(console.info);
    };

    document.addEventListener('swinger.user:authchange', checkBlocked);

    checkBlocked();
  });
})();
